import angular from 'angular';

import { rProjectedSalesImportButton } from '../../react/integrations/projectedSalesImport/ButtonAngular';

import Integrations from './components/integrations';
import Integration from './components/integration';
import IntegrationEntry from './components/integrationEntry';
import IntegrationOauth from './components/integrationOauth';
import Shift4LinkToken from './components/shift4LinkToken';
import IntegrationIssues from './components/integrationIssues';
import integrationSync from './directives/integrationSync';
import Service from './service.js';
import IntegrationParametersModal from './parametersModal';
import ConnectCodeModal from './connectCodeModal';
import IntegrationsEducationService from './services/IntegrationsEducation';

import './style.less';

export default angular
  .module('integrations', [])
  .config(($stateProvider) => {
    'ngInject';

    // TODO to be removed in the consequent release
    // same for whitelisted urls on integrated platforms
    $stateProvider.state('integrationOauth_OLD', {
      url: '/integrations/oauth?code&platform',
      component: 'integrationOauth',
      data: {
        title: 'OAuth Redirect',
      },
    });

    $stateProvider.state('integrationOauth', {
      url: '/integrations/:platform/oauth?code&origin&state&error',
      component: 'integrationOauth',
      data: {
        title: 'OAuth Redirect',
      },
    });

    $stateProvider.state('shift4LinkToken', {
      url: '/integrations/shift4?linkToken&origin',
      component: 'shift4LinkToken',
      data: {
        title: 'LinkToken Redirect (Shift4)',
      },
    });

    $stateProvider.state('integration', {
      url: '/integrations/:platform',
      component: 'integration',
      data: {
        title: 'Integrations',
      },
      resolve: {
        async pageTitle($state$, $stateParams, IntegrationService) {
          const integration = await IntegrationService.getIntegrationByPlatform(
            $stateParams.platform
          );
          if (!integration) {
            return;
          }
          $state$.data.title = `Integrations - ${integration.name}`;
        },
      },
    });
  })
  .component('integration', Integration)
  .component('integrations', Integrations)
  .component('integrationOauth', IntegrationOauth)
  .component('shift4LinkToken', Shift4LinkToken)
  .component('integrationEntry', IntegrationEntry)
  .component('integrationIssues', IntegrationIssues)
  .component('rProjectedSalesImportButton', rProjectedSalesImportButton)
  .directive('integrationSync', integrationSync)
  .service('IntegrationService', Service)
  .service('IntegrationParametersModal', IntegrationParametersModal)
  .service('ConnectCodeModal', ConnectCodeModal)
  .service('IntegrationsEducation', IntegrationsEducationService).name;
